import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles(() => ({
    btnDiv: {
        display: 'flex',
        justifyContent: "flex-end"
    },
    createBtn: {
        background: "#0a72ba",
        color: '#fff',
        border: 'none',
        borderRadius: 5,
        fontWeight: 'bold',
        cursor: 'pointer',
        width: 60,
        height: 30
    },
    popupBtnDiv: {
        height: 60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    submitBtn: {
        border: 'none',
        width: '100px',
        height: '35px',
        background: '#0a72ba',
        color: '#fff',
        margin: "25px 0px 0px 0px",
        cursor: 'pointer',
        borderRadius: 5
    },
    closeIcon: {
        fontSize: 16,
        position: 'absolute',
        top: 5,
        right: 5,
        cursor: 'pointer'
    },
    errorMsg: {
        fontSize: 12,
        color: "red",
        margin: 0,
        padding: 0
    },
    responsiveTable: {
        width: "100%",
        overflow: "auto",
        marginTop: 10
    },

    exportBtn: {
        color: "#fff",
        width: 60,
        height: 30,
        cursor: "pointer",
        borderRadius: 5,
        backgroundColor: "#0a72ba",
        border: "none",
        marginRight: "10px"
    },
    editBtn: {
        color: "#fff",
        backgroundColor: "#305698 !important",
        fontSize: 15,
        border: " 1px solid #2F7CBD",
        borderRadius: 10,
        textTransform: "capitalize",
        width: 100,
        "&:hover": {
          backgroundColor: "#305698 !important",
        },
    },
      editCancelBtn: {
        color: "#305698",
        backgroundColor: "#fff",
        fontSize: 15,
        border: " 1px solid #305698",
        borderRadius: 10,
        width: 100,
        textTransform: "capitalize",
        margin: "5px 0",
    },

}))
export const mpcDetailStyles = makeStyles((theme) => ({
    headGrid: {
      color: "#fff",
      fontSize: 25,
      display: "flex",
      alignSelf: "center",
      padding: 8,
    },
    headGridIcon: {
      fontSize: 35,
      alignSelf: "center",
      cursor: "pointer",
    },
    gridContainer: {
      marginTop: "2%",
    },
    badge: {
      backgroundColor: "#C52025",
      color: "#fff",
      fontWeight: "bold",
    },
    editBtn: {
      color: "#fff",
      backgroundColor: "#305698 !important",
      fontSize: 15,
      border: " 1px solid #2F7CBD",
      borderRadius: 10,
      textTransform: "capitalize",
      width: 100,
      "&:hover": {
        backgroundColor: "#305698 !important",
      },
    },
    editCancelBtn: {
      color: "#305698",
      backgroundColor: "#fff",
      fontSize: 15,
      border: " 1px solid #305698",
      borderRadius: 10,
      width: 100,
      textTransform: "capitalize",
      margin: "5px 0",
    },
    firstDiv: {
      width: "100%",
      height: 40,
      backgroundColor: "#E4E4E4",
      marginTop: 10,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    secondDiv: {
      color: "#707070",
      fontSize: 22,
      fontWeight: "bold",
      marginLeft: 10,
      "@media (max-width: 768px)": {
        fontSize: 20,
      },
    },
    grid: {
      padding: 10,
      fontSize: 16,
      alignSelf: "center",
    },
    gridSpan: {
      fontWeight: "bold",
    },
    gridBtn: {
      marginTop: 10,
    },
    activeSpan: {
      color: "green",
    },
    inActiveSpan: {
      color: "red",
    },
    cssTextField: {
      width: 200,
      "@media (max-width: 500px)": {
        width: 150,
      },
      "@media (max-width: 400px)": {
        width: 100,
      },
    },
  }));
  export const editMpcStyles = makeStyles((theme) => ({
    saveBtnGrid: {
      textAlign: "center",
    },
  }));